/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AddressRef,
  AddressRefOptional,
  AddressRefMetaI,
  AddressRefTrackedI,
} from "./address-ref";
import { AddressRefTracked, AddressRefMeta } from "./address-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonLookupRef,
  PersonLookupRefOptional,
  PersonLookupRefMetaI,
  PersonLookupRefTrackedI,
} from "./person-lookup-ref";
import {
  PersonLookupRefTracked,
  PersonLookupRefMeta,
} from "./person-lookup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryBase,
  PurchaseDeliveryBaseOptional,
  PurchaseDeliveryBaseMetaI,
  PurchaseDeliveryBaseTrackedI,
} from "./purchase-delivery-base";
import {
  PurchaseDeliveryBaseTracked,
  PurchaseDeliveryBaseMeta,
} from "./purchase-delivery-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryMethod,
  PurchaseDeliveryMethodOptional,
  PurchaseDeliveryMethodMetaI,
  PurchaseDeliveryMethodTrackedI,
} from "./purchase-delivery-method";
import {
  PurchaseDeliveryMethodTracked,
  PurchaseDeliveryMethodMeta,
} from "./purchase-delivery-method";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryRef,
  PurchaseDeliveryRefOptional,
  PurchaseDeliveryRefMetaI,
  PurchaseDeliveryRefTrackedI,
} from "./purchase-delivery-ref";
import {
  PurchaseDeliveryRefTracked,
  PurchaseDeliveryRefMeta,
} from "./purchase-delivery-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryStatus,
  PurchaseDeliveryStatusOptional,
  PurchaseDeliveryStatusMetaI,
  PurchaseDeliveryStatusTrackedI,
} from "./purchase-delivery-status";
import {
  PurchaseDeliveryStatusTracked,
  PurchaseDeliveryStatusMeta,
} from "./purchase-delivery-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryTarget,
  PurchaseDeliveryTargetOptional,
  PurchaseDeliveryTargetMetaI,
  PurchaseDeliveryTargetTrackedI,
} from "./purchase-delivery-target";
import {
  PurchaseDeliveryTargetTracked,
  PurchaseDeliveryTargetMeta,
} from "./purchase-delivery-target";

/**
 *
 * @export
 * @interface PurchaseDeliveryFull
 */
export interface PurchaseDeliveryFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDeliveryFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDeliveryFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDeliveryFull
   */
  assignId?: number;
  /**
   *
   * @type {PurchaseDeliveryTarget}
   * @memberof PurchaseDeliveryFull
   */
  target?: PurchaseDeliveryTarget;
  /**
   *
   * @type {PurchaseDeliveryMethod}
   * @memberof PurchaseDeliveryFull
   */
  method?: PurchaseDeliveryMethod;
  /**
   *
   * @type {PurchaseDeliveryStatus}
   * @memberof PurchaseDeliveryFull
   */
  deliveryStatus?: PurchaseDeliveryStatus;
  /**
   *
   * @type {string}
   * @memberof PurchaseDeliveryFull
   */
  deliveredOn?: Date;
  /**
   *
   * @type {PersonLookupRef}
   * @memberof PurchaseDeliveryFull
   */
  personLookup?: PersonLookupRefOptional;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseDeliveryFull
   */
  targetPerson?: PersonRefOptional;
  /**
   *
   * @type {AddressRef}
   * @memberof PurchaseDeliveryFull
   */
  targetAddress?: AddressRefOptional;
}

export interface PurchaseDeliveryFull
  extends
    PurchaseDeliveryFullOptional,
    Deletable,
    PurchaseDeliveryBase,
    PurchaseDeliveryRef {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDeliveryFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDeliveryFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDeliveryFull
   */
  assignId: number;
  /**
   *
   * @type {PurchaseDeliveryTarget}
   * @memberof PurchaseDeliveryFull
   */
  target?: PurchaseDeliveryTarget;
  /**
   *
   * @type {PurchaseDeliveryMethod}
   * @memberof PurchaseDeliveryFull
   */
  method?: PurchaseDeliveryMethod;
  /**
   *
   * @type {PurchaseDeliveryStatus}
   * @memberof PurchaseDeliveryFull
   */
  deliveryStatus?: PurchaseDeliveryStatus;
  /**
   *
   * @type {string}
   * @memberof PurchaseDeliveryFull
   */
  deliveredOn?: Date;
  /**
   *
   * @type {PersonLookupRef}
   * @memberof PurchaseDeliveryFull
   */
  personLookup?: PersonLookupRef;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseDeliveryFull
   */
  targetPerson?: PersonRef;
  /**
   *
   * @type {AddressRef}
   * @memberof PurchaseDeliveryFull
   */
  targetAddress?: AddressRef;
}

export interface PurchaseDeliveryFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDeliveryFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseDeliveryFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseDeliveryFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {PurchaseDeliveryTarget}
   * @memberof PurchaseDeliveryFull
   */
  target?: PurchaseDeliveryTarget;
  targetIsSet: boolean;
  /**
   *
   * @type {PurchaseDeliveryMethod}
   * @memberof PurchaseDeliveryFull
   */
  method?: PurchaseDeliveryMethod;
  methodIsSet: boolean;
  /**
   *
   * @type {PurchaseDeliveryStatus}
   * @memberof PurchaseDeliveryFull
   */
  deliveryStatus?: PurchaseDeliveryStatus;
  deliveryStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseDeliveryFull
   */
  deliveredOn?: Date;
  deliveredOnIsSet: boolean;
  /**
   *
   * @type {PersonLookupRef}
   * @memberof PurchaseDeliveryFull
   */
  personLookup?: PersonLookupRefTrackedI;
  personLookupIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PurchaseDeliveryFull
   */
  targetPerson?: PersonRefTrackedI;
  targetPersonIsSet: boolean;
  /**
   *
   * @type {AddressRef}
   * @memberof PurchaseDeliveryFull
   */
  targetAddress?: AddressRefTrackedI;
  targetAddressIsSet: boolean;
}

transformDatesMap.set(
  "PurchaseDeliveryFull",
  function (model: PurchaseDeliveryFull) {
    if (typeof model.deliveredOn == "string")
      model.deliveredOn = new Date(model.deliveredOn);
    const transformDatespersonLookup = transformDatesMap.get("PersonLookupRef");
    if (transformDatespersonLookup && model.personLookup) {
      transformDatespersonLookup(model.personLookup);
    }
    const transformDatestargetPerson = transformDatesMap.get("PersonRef");
    if (transformDatestargetPerson && model.targetPerson) {
      transformDatestargetPerson(model.targetPerson);
    }
    const transformDatestargetAddress = transformDatesMap.get("AddressRef");
    if (transformDatestargetAddress && model.targetAddress) {
      transformDatestargetAddress(model.targetAddress);
    }
  },
);

export type PurchaseDeliveryFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  target: PropertyMeta<PurchaseDeliveryTargetMetaI>;
  //isDate: false
  //isDatetime: false
  method: PropertyMeta<PurchaseDeliveryMethodMetaI>;
  //isDate: false
  //isDatetime: false
  deliveryStatus: PropertyMeta<PurchaseDeliveryStatusMetaI>;
  //isDate: false
  //isDatetime: true
  deliveredOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  personLookup: PropertyMeta<PersonLookupRefMetaI>;
  //isDate: false
  //isDatetime: false
  targetPerson: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  targetAddress: PropertyMeta<AddressRefMetaI>;
}>;

export var PurchaseDeliveryFullMeta: PurchaseDeliveryFullMetaI =
  {} as PurchaseDeliveryFullMetaI;
PurchaseDeliveryFullMeta = typeMeta("PurchaseDeliveryFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  target: propertyMeta(
    "target",
    false,
    false,
    false,
    PurchaseDeliveryTargetMeta,
  ),
  method: propertyMeta(
    "method",
    false,
    false,
    false,
    PurchaseDeliveryMethodMeta,
  ),
  deliveryStatus: propertyMeta(
    "deliveryStatus",
    false,
    false,
    false,
    PurchaseDeliveryStatusMeta,
  ),
  deliveredOn: propertyMeta(
    "deliveredOn",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  personLookup: propertyMeta(
    "personLookup",
    false,
    false,
    false,
    PersonLookupRefMeta,
  ),
  targetPerson: propertyMeta(
    "targetPerson",
    false,
    false,
    false,
    PersonRefMeta,
  ),
  targetAddress: propertyMeta(
    "targetAddress",
    false,
    false,
    false,
    AddressRefMeta,
  ),
});

const metaI = PurchaseDeliveryFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([PurchaseDeliveryRefMeta]);
  metaI.assignId.inheritedFrom = PurchaseDeliveryRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([PurchaseDeliveryBaseMeta]);
  metaI.target.inheritedFrom = PurchaseDeliveryBaseMeta.target;
  metaI.method.inheritedFrom = PurchaseDeliveryBaseMeta.method;
  metaI.deliveryStatus.inheritedFrom = PurchaseDeliveryBaseMeta.deliveryStatus;
  metaI.deliveredOn.inheritedFrom = PurchaseDeliveryBaseMeta.deliveredOn;
});

export class PurchaseDeliveryFullTracked
  extends DeletableTracked
  implements PurchaseDeliveryFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  target__I?: PurchaseDeliveryTarget = undefined;
  targetIsSet: boolean = false;
  set target(v: undefined | PurchaseDeliveryTarget) {
    if (v !== undefined) {
      this.target__I = v;
      this.targetIsSet = true;
    } else {
      this.target__I = v || undefined;
      this.targetIsSet = false;
    }
    this.changeTracker = true;
  }
  get target() {
    return this.target__I;
  }
  method__I?: PurchaseDeliveryMethod = undefined;
  methodIsSet: boolean = false;
  set method(v: undefined | PurchaseDeliveryMethod) {
    if (v !== undefined) {
      this.method__I = v;
      this.methodIsSet = true;
    } else {
      this.method__I = v || undefined;
      this.methodIsSet = false;
    }
    this.changeTracker = true;
  }
  get method() {
    return this.method__I;
  }
  deliveryStatus__I?: PurchaseDeliveryStatus = undefined;
  deliveryStatusIsSet: boolean = false;
  set deliveryStatus(v: undefined | PurchaseDeliveryStatus) {
    if (v !== undefined) {
      this.deliveryStatus__I = v;
      this.deliveryStatusIsSet = true;
    } else {
      this.deliveryStatus__I = v || undefined;
      this.deliveryStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get deliveryStatus() {
    return this.deliveryStatus__I;
  }
  deliveredOn__I?: Date = undefined;
  deliveredOnIsSet: boolean = false;
  set deliveredOn(v: undefined | Date) {
    if (v !== undefined) {
      this.deliveredOn__I = v;
      this.deliveredOnIsSet = true;
    } else {
      this.deliveredOn__I = v || undefined;
      this.deliveredOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get deliveredOn() {
    return this.deliveredOn__I;
  }
  personLookup__I?: PersonLookupRefTracked = undefined;
  personLookupIsSet: boolean = false;
  set personLookup(v: undefined | PersonLookupRefTracked) {
    if (v !== undefined) {
      this.personLookup__I = v;
      this.personLookupIsSet = true;
    } else {
      this.personLookup__I = v || undefined;
      this.personLookupIsSet = false;
    }
    this.changeTracker = true;
  }
  get personLookup() {
    return this.personLookup__I;
  }
  targetPerson__I?: PersonRefTracked = undefined;
  targetPersonIsSet: boolean = false;
  set targetPerson(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.targetPerson__I = v;
      this.targetPersonIsSet = true;
    } else {
      this.targetPerson__I = v || undefined;
      this.targetPersonIsSet = false;
    }
    this.changeTracker = true;
  }
  get targetPerson() {
    return this.targetPerson__I;
  }
  targetAddress__I?: AddressRefTracked = undefined;
  targetAddressIsSet: boolean = false;
  set targetAddress(v: undefined | AddressRefTracked) {
    if (v !== undefined) {
      this.targetAddress__I = v;
      this.targetAddressIsSet = true;
    } else {
      this.targetAddress__I = v || undefined;
      this.targetAddressIsSet = false;
    }
    this.changeTracker = true;
  }
  get targetAddress() {
    return this.targetAddress__I;
  }
  constructor(config?: PurchaseDeliveryFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personLookup?.setIds();

    this.targetPerson?.setIds();

    this.targetAddress?.setIds();
  }
  assignFrom(
    config: PurchaseDeliveryFullOptional,
    options?: AssignOptions,
  ): PurchaseDeliveryFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.target && this.targetApplyFilter(optionsRequired.filter)) {
      this.target = config.target;
      if (optionsRequired.unassign) this.targetIsSet = false;
      else this.targetIsSet = true;
    }
    if (config.method && this.methodApplyFilter(optionsRequired.filter)) {
      this.method = config.method;
      if (optionsRequired.unassign) this.methodIsSet = false;
      else this.methodIsSet = true;
    }
    if (
      config.deliveryStatus &&
      this.deliveryStatusApplyFilter(optionsRequired.filter)
    ) {
      this.deliveryStatus = config.deliveryStatus;
      if (optionsRequired.unassign) this.deliveryStatusIsSet = false;
      else this.deliveryStatusIsSet = true;
    }
    if (
      config.deliveredOn &&
      this.deliveredOnApplyFilter(optionsRequired.filter)
    ) {
      this.deliveredOn = config.deliveredOn;
      if (optionsRequired.unassign) this.deliveredOnIsSet = false;
      else this.deliveredOnIsSet = true;
    }
    if (
      config.personLookup &&
      this.personLookupApplyFilter(optionsRequired.filter)
    ) {
      this.personLookup = new PersonLookupRefTracked(
        config.personLookup,
        options,
      );
      if (optionsRequired.unassign) this.personLookupIsSet = false;
      else this.personLookupIsSet = true;
    }
    if (
      config.targetPerson &&
      this.targetPersonApplyFilter(optionsRequired.filter)
    ) {
      this.targetPerson = new PersonRefTracked(config.targetPerson, options);
      if (optionsRequired.unassign) this.targetPersonIsSet = false;
      else this.targetPersonIsSet = true;
    }
    if (
      config.targetAddress &&
      this.targetAddressApplyFilter(optionsRequired.filter)
    ) {
      this.targetAddress = new AddressRefTracked(config.targetAddress, options);
      if (optionsRequired.unassign) this.targetAddressIsSet = false;
      else this.targetAddressIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PurchaseDeliveryFullTrackedI {
    const cloned = {} as PurchaseDeliveryFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.targetIsSetDeep() &&
      this.targetApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.targetIsSet = true;
      cloned.target = this.target;
    } else {
      //cloned.targetIsSet = false
    }
    if (
      this.methodIsSetDeep() &&
      this.methodApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.methodIsSet = true;
      cloned.method = this.method;
    } else {
      //cloned.methodIsSet = false
    }
    if (
      this.deliveryStatusIsSetDeep() &&
      this.deliveryStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.deliveryStatusIsSet = true;
      cloned.deliveryStatus = this.deliveryStatus;
    } else {
      //cloned.deliveryStatusIsSet = false
    }
    if (
      this.deliveredOnIsSetDeep() &&
      this.deliveredOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.deliveredOnIsSet = true;
      cloned.deliveredOn = this.deliveredOn;
    } else {
      //cloned.deliveredOnIsSet = false
    }
    if (
      this.personLookupIsSetDeep() &&
      this.personLookupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personLookupIsSet = true;
      cloned.personLookup = this.personLookup?.removeUnset(filter);
    } else {
      //cloned.personLookupIsSet = false
    }
    if (
      this.targetPersonIsSetDeep() &&
      this.targetPersonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.targetPersonIsSet = true;
      cloned.targetPerson = this.targetPerson?.removeUnset(filter);
    } else {
      //cloned.targetPersonIsSet = false
    }
    if (
      this.targetAddressIsSetDeep() &&
      this.targetAddressApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.targetAddressIsSet = true;
      cloned.targetAddress = this.targetAddress?.removeUnset(filter);
    } else {
      //cloned.targetAddressIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PurchaseDeliveryFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.targetApplyFilter(filter)) this.targetIsSet = false;

    if (!this.methodApplyFilter(filter)) this.methodIsSet = false;

    if (!this.deliveryStatusApplyFilter(filter))
      this.deliveryStatusIsSet = false;

    if (!this.deliveredOnApplyFilter(filter)) this.deliveredOnIsSet = false;

    if (!this.personLookupApplyFilter(filter)) this.personLookupIsSet = false;
    this.personLookup?.unassignAll(filter);

    if (!this.targetPersonApplyFilter(filter)) this.targetPersonIsSet = false;
    this.targetPerson?.unassignAll(filter);

    if (!this.targetAddressApplyFilter(filter)) this.targetAddressIsSet = false;
    this.targetAddress?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.isDeleted,
      PurchaseDeliveryFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.isNew,
      PurchaseDeliveryFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.assignId,
      PurchaseDeliveryFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  targetApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.target,
      PurchaseDeliveryFullMeta,
      this.target,
      this,
    );
  }
  targetIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.targetIsSet && this.targetApplyFilter(filter)) return true;

    return false;
  }
  methodApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.method,
      PurchaseDeliveryFullMeta,
      this.method,
      this,
    );
  }
  methodIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.methodIsSet && this.methodApplyFilter(filter)) return true;

    return false;
  }
  deliveryStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.deliveryStatus,
      PurchaseDeliveryFullMeta,
      this.deliveryStatus,
      this,
    );
  }
  deliveryStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.deliveryStatusIsSet && this.deliveryStatusApplyFilter(filter))
      return true;

    return false;
  }
  deliveredOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.deliveredOn,
      PurchaseDeliveryFullMeta,
      this.deliveredOn,
      this,
    );
  }
  deliveredOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.deliveredOnIsSet && this.deliveredOnApplyFilter(filter))
      return true;

    return false;
  }
  personLookupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.personLookup,
      PurchaseDeliveryFullMeta,
      this.personLookup,
      this,
    );
  }
  personLookupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personLookupIsSet && this.personLookupApplyFilter(filter))
      return true;
    return this.personLookup?.anySet(filter) == true;

    return false;
  }
  targetPersonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.targetPerson,
      PurchaseDeliveryFullMeta,
      this.targetPerson,
      this,
    );
  }
  targetPersonIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.targetPersonIsSet && this.targetPersonApplyFilter(filter))
      return true;
    return this.targetPerson?.anySet(filter) == true;

    return false;
  }
  targetAddressApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryFullMeta.targetAddress,
      PurchaseDeliveryFullMeta,
      this.targetAddress,
      this,
    );
  }
  targetAddressIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.targetAddressIsSet && this.targetAddressApplyFilter(filter))
      return true;
    return this.targetAddress?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.targetIsSetDeep(filter)) return true;
    if (this.methodIsSetDeep(filter)) return true;
    if (this.deliveryStatusIsSetDeep(filter)) return true;
    if (this.deliveredOnIsSetDeep(filter)) return true;
    if (this.personLookupIsSetDeep(filter)) return true;
    if (this.targetPersonIsSetDeep(filter)) return true;
    if (this.targetAddressIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
